import Merchant from "../../../model/merchant/Merchant";

/**
 * Fetch merchants successful action.
 */
export const MERCHANTS_FETCHED = "MERCHANTS_FETCHED";
export type MERCHANTS_FETCHED = { merchants: Array<Merchant> }

/**
 * Create merchant successful action.
 */
export const MERCHANT_CREATED = "MERCHANT_CREATED";
export type MERCHANT_CREATED = { merchant: Merchant }

/**
 * Update merchant successful action.
 */
export const MERCHANT_UPDATED = "MERCHANT_UPDATED";
export type MERCHANT_UPDATED = { merchant: Merchant }

/**
 *  Update merchants sort order successful action.
 */
export const MERCHANT_SORT_ORDER_UPDATED = "MERCHANT_SORT_ORDER_UPDATED";
export type MERCHANT_SORT_ORDER_UPDATED = { merchants: Array<Merchant> }

